import { createContext } from 'react';

import { ControllerProps } from '../types';

export const ControllerPropsContext = createContext<ControllerProps | undefined>(undefined);
